import { useQuery } from '@tanstack/react-query';

import { useLocale } from 'hooks/useLocale';
import { StaleTime } from 'queries/types';

import { affiliateByTicketingQuery } from './queries';

export const useAffiliateByTicketingSlug = (ticketingPlatformSlug?: string) => {
  const { locale } = useLocale();

  /**
   * Query
   */
  const QueryAffiliate = useQuery({
    ...affiliateByTicketingQuery({
      locale,
      ticketingPlatformSlug,
    }),
    retry: false,
    enabled: !!ticketingPlatformSlug,
    staleTime: StaleTime.FIVE_MIN,
  });

  return {
    affiliate: QueryAffiliate.data?.affiliatePartner,
    isLoading: QueryAffiliate.isLoading,
    isSuccess: QueryAffiliate.isSuccess,
    error: QueryAffiliate.error,
  };
};
